export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '66dfa032-491e-40d6-ab3b-a443b95eb818';
export const MODAL_CLOSE_SEC = 2.5;
